import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["src", "alt", "size", "dimmed", "outlineWidth", "id"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React, { forwardRef } from 'react';
import styled from 'styled-components';
import useUniqueId from 'hooks/useUniqueId';
import { pxToRem } from 'utils/ui';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Svg = styled.svg.withConfig({
  displayName: "StickerImage__Svg",
  componentId: "sc-w95sum-0"
})(["width:", ";height:auto;overflow:visible;"], function (p) {
  return pxToRem(p.width);
});
var StickerImage = /*#__PURE__*/forwardRef(function (props, ref) {
  var src = props.src,
    alt = props.alt,
    _props$size = props.size,
    size = _props$size === void 0 ? 60 : _props$size,
    _props$dimmed = props.dimmed,
    dimmed = _props$dimmed === void 0 ? false : _props$dimmed,
    outlineWidthProp = props.outlineWidth,
    id = props.id,
    otherProps = _objectWithoutProperties(props, _excluded);
  var outlineWidth = outlineWidthProp || size / 30;
  var safetyMargin = outlineWidth * 1.3;
  var imageSize = size - safetyMargin * 2;
  var dropShadowStrength = 0.25;
  var uniqueId = useUniqueId(id);
  var filterId = "".concat(uniqueId, "-filter");
  return /*#__PURE__*/_jsxs(Svg, _objectSpread(_objectSpread({}, otherProps), {}, {
    ref: ref,
    id: uniqueId,
    width: size,
    height: size,
    viewBox: "0 0 ".concat(size, " ").concat(size),
    role: "img",
    "aria-label": alt,
    children: [/*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsxs("filter", {
        id: filterId,
        children: [/*#__PURE__*/_jsx("feMorphology", {
          operator: "dilate",
          radius: outlineWidth,
          in: "SourceAlpha",
          result: "THICKEN"
        }), /*#__PURE__*/_jsx("feFlood", {
          floodColor: "#FFFFFF",
          result: "COLOR_WASH"
        }), /*#__PURE__*/_jsx("feComposite", {
          in: "COLOR_WASH",
          in2: "THICKEN",
          operator: "in",
          result: "OUTLINE"
        }), /*#__PURE__*/_jsx("feFlood", {
          floodColor: "#FFFFFF",
          floodOpacity: "0.3333",
          result: "DIM_WASH"
        }), /*#__PURE__*/_jsx("feComposite", {
          in: "DIM_WASH",
          in2: "SourceAlpha",
          operator: "in",
          result: "DIM_SHAPE"
        }), /*#__PURE__*/_jsxs("feMerge", {
          children: [/*#__PURE__*/_jsx("feMergeNode", {
            in: "OUTLINE"
          }), /*#__PURE__*/_jsx("feMergeNode", {
            in: "SourceGraphic"
          }), dimmed && /*#__PURE__*/_jsx("feMergeNode", {
            in: "DIM_SHAPE"
          })]
        }), dimmed && /*#__PURE__*/_jsx("feColorMatrix", {
          type: "saturate",
          values: "0"
        }), /*#__PURE__*/_jsx("feDropShadow", {
          dx: "0",
          dy: "1",
          stdDeviation: "1.2",
          floodOpacity: dropShadowStrength,
          floodColor: "black"
        })]
      })
    }), /*#__PURE__*/_jsx("image", {
      xlinkHref: src,
      x: safetyMargin,
      y: safetyMargin,
      width: imageSize,
      height: imageSize,
      filter: "url(#".concat(filterId, ")")
    })]
  }));
});
StickerImage.displayName = 'StickerImage';
export default StickerImage;